import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { IProduct } from '@/interfaces/product';
import { SearchOutlined } from '@ant-design/icons';
import ProductSelectorModal from '../product/product-selector-modal';

interface IProps {
  size?: SizeType;
  handleSelectData: (item: IProduct) => void;
  isMultiSelect?: boolean;
}

const ProductFinderSelector = ({
  size = 'large',
  handleSelectData,
  isMultiSelect = false,
}: IProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="ค้นหา">
        <Button
          size={size}
          icon={<SearchOutlined />}
          title="ค้นหา"
          onClick={() => setOpen(true)}
        />
        <ProductSelectorModal
          handleCancel={() => setOpen(false)}
          handleOk={item => {
            handleSelectData(item[0]);
            setOpen(false);
          }}
          open={open}
          isMultiSelect={isMultiSelect}
        />
      </Tooltip>
    </>
  );
};

export default ProductFinderSelector;
